import { Table } from "react-bootstrap";

const NavPillTrackingCompanyTable = ({ trackingData }) => {
  return (
    <Table
      striped
      bordered
      responsive
      className="mb-5"
      style={{ textAlign: "center" }}
    >
      <thead>
        <tr>
          <th className="text-secondary">ردیف</th>
          <th className="text-secondary">تاریخ</th>
          <th className="text-secondary">ساعت</th>
          <th className="text-secondary">مکان</th>
          <th className="text-secondary">وضعیت</th>
          <th className="text-secondary">توضیحات</th>
        </tr>
      </thead>
      <tbody>
        {trackingData.history?.map((item, index) => (
          <tr key={index} className="">
            <td>{index + 1}</td>
            <td>{item.localDate}</td>
            <td>{item.time}</td>
            <td>{item.location}</td>
            <td>{item.state}</td>
            <td>{item.comment}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
export default NavPillTrackingCompanyTable;
